import React from "react";
import CardSlide from "./Slider/card_slide";
import Image1 from "../../assets/images/yourstylist/IMG_2751.jpg";
import Image2 from "../../assets/images/yourstylist/DSCF4965.jpg";
import Image3 from "../../assets/images/yourstylist/DSCF5159.jpg";
import Image4 from "../../assets/images/yourstylist/DSCF4991.jpg";
import Image5 from "../../assets/images/yourstylist/DSCF5136.jpg";
import Image6 from "../../assets/images/yourstylist/DSCF3998.jpg";
import { motion } from "framer-motion";

export const SlideData = [
  {
    id: 1,
    name: "Summer Fairy",
    cate: "34,000 MMK",
    img: Image1,
  },
  {
    id: 2,
    name: "Sunny Top",
    cate: "34,000 MMK",
    img: Image2,
  },
  {
    id: 3,
    name: "Cupid",
    cate: " 34,000 MMK",
    img: Image3,
  },
  {
    id: 4,
    name: "Ava",
    cate: "34,000 MMK",
    img: Image4,
  },
  {
    id: 5,
    name: "Olivia Dress",
    cate: "29,500 MMK",
    img: Image5,
  },
  {
    id: 6,
    name: "Helter Neck Dress",
    cate: "39,500 MMK",
    img: Image6,
  },
];
const Products = ({ title, subTitle }) => {
  return (
    <div className=" w-screen px-5">
      <motion.div
        initial={{ y: 100 }}
        whileInView={{ y: 0 }}
        className="text-center mb-5 mt-10"
      >
        <h2 className="uppercase text-[13px] ">{title}</h2>
        <h1 className="uppercase text-[22px]">{subTitle}</h1>
      </motion.div>
      <div className="lg:mx-[90px]  ">
        <CardSlide SlideData={SlideData} />
      </div>
      <div className="text-center mt-10">
        <a href={"https://yourstylistclothing.com/"}>
          <button className="bg-black text-white  text-sm uppercase px-6 py-2 ">
            Shop now
          </button>
        </a>
      </div>
      <hr className="mt-10" />
    </div>
  );
};

export default Products;
